import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-6 pt-6 pb-4 border-b border-black/5" }
const _hoisted_2 = { class: "text-[1.7rem] font-bold text-[#0f1f2e]" }
const _hoisted_3 = {
  key: 0,
  class: "p-6 flex flex-col gap-3"
}
const _hoisted_4 = { class: "text-[1.35rem] text-[#627282] mb-2" }
const _hoisted_5 = {
  key: 1,
  class: "p-6 flex flex-col gap-4"
}
const _hoisted_6 = ["value", "placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "text-red-500 text-[1.3rem]"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 2,
  class: "p-6 text-center flex flex-col items-center gap-3"
}
const _hoisted_10 = { class: "text-[1.7rem] font-bold text-[#0f1f2e]" }
const _hoisted_11 = { class: "text-[1.35rem] text-[#627282]" }

import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";
import PopUp from "@/components/popup/PopUp.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GuestJoinPopup',
  props: {
    isOpen: { type: Boolean },
    guestJoinState: {},
    guestJoinEmail: {},
    guestJoinLoading: { type: Boolean },
    guestJoinError: {}
  },
  emits: ["close", "login", "register", "update:guestJoinEmail", "update:guestJoinState", "submit-email"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const { t } = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopUp, {
    "model-value": __props.isOpen,
    size: "sm",
    "onUpdate:modelValue": _cache[9] || (_cache[9] = v => !v && emit('close'))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("guestJoinTitle")), 1),
        _createElementVNode("button", {
          class: "text-[#9ab4c0] hover:text-[#0f1f2e] transition",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, [...(_cache[10] || (_cache[10] = [
          _createElementVNode("svg", {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round"
          }, [
            _createElementVNode("line", {
              x1: "18",
              y1: "6",
              x2: "6",
              y2: "18"
            }),
            _createElementVNode("line", {
              x1: "6",
              y1: "6",
              x2: "18",
              y2: "18"
            })
          ], -1)
        ]))])
      ]),
      (__props.guestJoinState === 'options')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("guestJoinSubtitle")), 1),
            _createElementVNode("button", {
              class: "w-full py-3 rounded-xl bg-[#0f1f2e] text-white text-[1.4rem] font-semibold hover:opacity-90 transition",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('login')))
            }, _toDisplayString(_unref(t)("guestJoinLogin")), 1),
            _createElementVNode("button", {
              class: "w-full py-3 rounded-xl border border-[#0f1f2e] text-[#0f1f2e] text-[1.4rem] font-semibold hover:bg-slate-50 transition",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('register')))
            }, _toDisplayString(_unref(t)("guestJoinRegister")), 1),
            _createElementVNode("button", {
              class: "w-full py-3 rounded-xl border border-black/10 text-[#627282] text-[1.4rem] font-medium hover:bg-slate-50 transition",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('update:guestJoinState', 'email')))
            }, _toDisplayString(_unref(t)("guestJoinGuest")), 1)
          ]))
        : (__props.guestJoinState === 'email')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("input", {
                value: __props.guestJoinEmail,
                type: "email",
                class: "w-full rounded-xl border border-black/15 px-4 py-3 text-[1.4rem] text-[#1a2e3b] placeholder-[#9ab4c0] outline-none focus:border-[#0f1f2e] transition",
                placeholder: _unref(t)('guestJoinEmailPlaceholder'),
                onInput: _cache[4] || (_cache[4] = ($event: any) => (emit('update:guestJoinEmail', ($event.target as HTMLInputElement).value))),
                onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (emit('submit-email')), ["enter"]))
              }, null, 40, _hoisted_6),
              (__props.guestJoinError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.guestJoinError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "w-full py-3 rounded-xl bg-[#0f1f2e] text-white text-[1.4rem] font-semibold hover:opacity-90 transition disabled:opacity-40",
                disabled: __props.guestJoinLoading || !__props.guestJoinEmail.trim(),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('submit-email')))
              }, _toDisplayString(__props.guestJoinLoading ? _unref(t)("guestJoinSending") : _unref(t)("guestJoinSend")), 9, _hoisted_8),
              _createElementVNode("button", {
                class: "text-[1.3rem] text-[#9ab4c0] hover:text-[#0f1f2e] transition",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (emit('update:guestJoinState', 'options')))
              }, "← " + _toDisplayString(_unref(t)("back")), 1)
            ]))
          : (__props.guestJoinState === 'sent')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "w-12 h-12 rounded-full bg-green-50 flex items-center justify-center mb-1" }, [
                  _createElementVNode("svg", {
                    width: "22",
                    height: "22",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "#22c55e",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round"
                  }, [
                    _createElementVNode("path", { d: "M20 6L9 17l-5-5" })
                  ])
                ], -1)),
                _createElementVNode("h4", _hoisted_10, _toDisplayString(_unref(t)("guestJoinSentTitle")), 1),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)("guestJoinSentBody")), 1),
                _createElementVNode("button", {
                  class: "mt-3 px-6 py-3 rounded-xl bg-[#0f1f2e] text-white text-[1.4rem] font-semibold hover:opacity-90 transition",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (emit('close')))
                }, _toDisplayString(_unref(t)("close")), 1)
              ]))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})